import { render, staticRenderFns } from "./Synchro.vue?vue&type=template&id=97e2c8ea&scoped=true&"
import script from "./Synchro.vue?vue&type=script&lang=js&"
export * from "./Synchro.vue?vue&type=script&lang=js&"
import style0 from "./Synchro.vue?vue&type=style&index=0&id=97e2c8ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e2c8ea",
  null
  
)

export default component.exports